// Copyright (c) 2017 Deere & Company

import CreateClaimModal, {getDefaultState} from '../../../shared/state/create-claim-modal';
import actions from '../../action-list';

const updateClaimTypes = (state, action) =>
    CreateClaimModal.update(state, {
        claimTypes: {
            $set: action.claimTypes
        }
    });

const updateCreateClaimModalVisibility = (state, action) =>
    CreateClaimModal.update(state, {
        $merge: {
            isModalOpen: action.isOpen,
            selectedPin: action.pin
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_ALL_CLAIMS_CLAIM_TYPES]: updateClaimTypes,
        [actions.UPDATE_ALL_CLAIMS_CREATE_CLAIM_MODAL_VISIBILITY]: updateCreateClaimModalVisibility
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/all-claims/reducers/create-claim.js